import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Mail, Phone } from "lucide-react";
import { SITE } from "@/siteConfig";
import { BookCallLink } from "@/components/BookCall";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-navy-ink" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/logo-horizontal.png"
            alt="QuInflection Advisory — Own Your Turning Point"
            className="w-full max-w-md h-auto"
            data-testid="footer-logo"
          />
          <p className="mt-6 max-w-sm font-sans text-sm leading-relaxed text-white/50">
            Executive coaching, operational leadership, and AI-enabled transformation for
            growing companies across Canada.
          </p>
          <BookCallLink testid="footer-book-call" className="btn-primary mt-8">
            Book a Call
            <ArrowUpRight className="h-4 w-4" />
          </BookCallLink>
        </div>

        <div className="md:col-span-3">
          <p className="overline-label mb-6">Navigate</p>
          <ul className="space-y-3 font-sans text-sm">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Services", "/services"],
              ["Insights", "/blog"],
              ["Contact", "/contact"],
              ["Privacy Policy", "/privacy"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="text-white/60 transition-colors duration-300 hover:text-teal"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline-label mb-6">Connect</p>
          <ul className="space-y-4 font-sans text-sm">
            <li>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-white/60 transition-colors duration-300 hover:text-teal"
              >
                <Mail className="h-4 w-4 text-teal" /> {SITE.email}
              </a>
            </li>
            <li>
              <a
                href={SITE.phoneHref}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-white/60 transition-colors duration-300 hover:text-teal"
              >
                <Phone className="h-4 w-4 text-teal" /> {SITE.phone}
              </a>
            </li>
            <li>
              <a
                href={SITE.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="flex items-center gap-3 text-white/60 transition-colors duration-300 hover:text-teal"
              >
                <Linkedin className="h-4 w-4 text-teal" /> {SITE.founder} — LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 font-sans text-xs text-white/40 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
        <p>{SITE.name} — {SITE.tagline}</p>
      </div>
    </div>
  </footer>
);
